export default __webpack_public_path__ + "static/media/ActivityMobile.613adf16.svg";